import { createFileRoute } from '@tanstack/react-router';
import EvBatteryPercOnline from '../../../components/Graphs/EvBatteryPerc';

export const Route = createFileRoute('/_authenticated/graphs/ev-battery-percent/$vehicleId')({
  beforeLoad: ({ context }) => {
    // requirePermission(PERMISSION_RIDES, ['read']);
    return {
      ...context,
      documentTitle: {
        main: 'enum.onlineMap.widget.types.evBattery',
        params: { valueType: '%' },
        // suffix: 'menu.overviewTours',
      },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EvBatteryPercentGraphRoute,
});

function EvBatteryPercentGraphRoute() {
  const { vehicleId } = Route.useParams();

  return <EvBatteryPercOnline vehicleId={Number(vehicleId)} isPage />;
}
